import { ODB_KEYS, getOriginDestinationBaseUrl } from ".";
import type { ApiResponse } from ".";
import { queryOptions } from "@tanstack/react-query";

export type NearbyAirports = ApiResponse<{
  airports: {
    name: string;
    code: string;
    location: {
      longitude: number;
      latitude: number;
      distance: number;
    };
  }[];
}>;
export const getNearbyAirports = async () => {
  const baseUrl = await getOriginDestinationBaseUrl();

  const response = await fetch(`${baseUrl}/nearby-airports`);
  if (!response.ok) {
    throw new Error(`Failed to fetch data: ${response.statusText}`);
  }
  return (await response.json()) as NearbyAirports;
};
export const nearbyAirportsOptions = () =>
  queryOptions({
    queryFn: () => getNearbyAirports(),
    queryKey: [...ODB_KEYS(), "nearby-airports"] as const,
  });
